import { call, take, takeLatest } from "redux-saga/effects";
import {
  CREATE_DISTRIBUTOR,
  DISTRIBUTOR_DETAIL,
  DISTRIBUTOR_DISTRICT_EDIT,
  DISTRIBUTOR_DIVISION_LIST,
  DISTRIBUTOR_LIST,
  DISTRIBUTOR_ONBOARDING_LIST,
  ENABLE_DISABLE_DISTRIBUTOR,
  FETCH_DISTRIBUTOR_DISTRICTS,
  LINK_DISTRIBUTOR,
  LINK_DISTRIBUTOR_LIST,
  MANUFACTURER_DROPDOWN,
  SEND_MAIL,
} from "../actions/types";
import * as distributorApis from "../apis/distributorApis";

export function* distributorListWorker(action) {
  try {
    const res = yield call(distributorApis.distributorListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* distributorOnboardingListWorker(action) {
  try {
    const res = yield call(distributorApis.distributorOnboardListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorDetailWorker(action) {
  try {
    const res = yield call(distributorApis.distributorDetailApi, {
      distributor_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorEnableDisableWorker(action) {
  try {
    const res = yield call(distributorApis.distributorEnableDisable, {
      distributor_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorLinkWorker(action) {
  try {
    const res = yield call(distributorApis.distributorLinkApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* listDistributorLinkWorker(action) {
  try {
    const res = yield call(distributorApis.LinkdistributorListApi);
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.distributor_id,
        label: ele.distributor_id,
        offer_type: ele.offer_type,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchDistributorDistrictsWorker(action) {
  try {
    const res = yield call(distributorApis.fetchDistributorDistrictsApi, {
      distributor_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* editDistributorDistrictsWorker(action) {
  try {
    const res = yield call(
      distributorApis.editDistributorDistrictsApi,
      action.data
    );
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* sendMailWorker(action) {
  try {
    const res = yield call(distributorApis.sendMailApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* divisionListWorker(action) {
  try {
    const res = yield call(distributorApis.divisionsOptionsApi);
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* distributorCreateWorker(action) {
  try {
    const res = yield call(distributorApis.distributorCreateApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorListWatcher() {
  yield takeLatest(DISTRIBUTOR_LIST, distributorListWorker);
}

export function* distributorDetailWatcher() {
  yield takeLatest(DISTRIBUTOR_DETAIL, distributorDetailWorker);
}

export function* distributorEnableDisableWatcher() {
  yield takeLatest(ENABLE_DISABLE_DISTRIBUTOR, distributorEnableDisableWorker);
}

export function* distributorLinkWatcher() {
  yield takeLatest(LINK_DISTRIBUTOR, distributorLinkWorker);
}

export function* listDistributorLinkWatcher() {
  yield takeLatest(LINK_DISTRIBUTOR_LIST, listDistributorLinkWorker);
}

export function* fetchDistributorDistrictsWatcher() {
  yield takeLatest(
    FETCH_DISTRIBUTOR_DISTRICTS,
    fetchDistributorDistrictsWorker
  );
}

export function* editDistributorDistrictsWatcher() {
  yield takeLatest(DISTRIBUTOR_DISTRICT_EDIT, editDistributorDistrictsWorker);
}

export function* sendMailWatcher() {
  yield takeLatest(SEND_MAIL, sendMailWorker);
}
export function* dropdivisionListWatcher() {
  yield takeLatest(DISTRIBUTOR_DIVISION_LIST, divisionListWorker);
}
export function* distributorCreateWatcher() {
  yield takeLatest(CREATE_DISTRIBUTOR, distributorCreateWorker);
}
export function* distributorOnboardingListWatcher() {
  yield takeLatest(DISTRIBUTOR_ONBOARDING_LIST , distributorOnboardingListWorker);
}